/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { Heading, PlaceholderText } from 'sarsaparilla';

import { FavoriteHeart } from 'shared-ui/favorites';

import type { BreadcrumbPath } from './SharedVenuePage.types';

export interface FacilityPageHeaderProps {
    isLoading?: boolean;
    title: string;
    partOf?: BreadcrumbPath;
    starRating: React.ReactNode;
    cellRating?: React.ReactNode;
    favoriteEntityId?: string;
    favoriteEntityType?: string;
    favoriteParentId?: string;
    favoriteParentType?: string;
}

export function FacilityPageHeader({
    isLoading = false,
    title,
    partOf,
    starRating,
    cellRating,
    favoriteEntityId,
    favoriteEntityType,
    favoriteParentId,
    favoriteParentType,
}: FacilityPageHeaderProps) {
    if (isLoading) {
        return (
            <div className="permit-facility-page-header">
                <PlaceholderText fontSize={33} lineHeight={39} />
                <ul className="rec-subhead-wrap">
                    <li>
                        <PlaceholderText fontSize={19} lineHeight={23} width="195px" />
                    </li>
                    <li className="rec-subhead-rating">
                        <PlaceholderText fontSize={19} lineHeight={23} width="175px" />
                    </li>
                    <li className="rec-subhead-cell-rating">
                        <PlaceholderText fontSize={19} lineHeight={23} width="160px" />
                    </li>
                </ul>
            </div>
        );
    }

    return (
        <div className="permit-facility-page-header">
            {/* Main title of the page */}
            {title && (
                <Heading headingLevel={1} appearance="h3" className="mb-1" translate="no">
                    {title}
                </Heading>
            )}

            {/* "Part of" statement and star rating */}
            <ul className="rec-subhead-wrap">
                <li key={partOf?.url}>
                    Part of{' '}
                    <span translate="no">
                        {partOf?.url ? (
                            <a href={partOf?.url}>{partOf?.title}</a>
                        ) : (
                            partOf?.title
                        )}
                    </span>
                </li>

                {starRating && <li className="rec-subhead-rating">{starRating}</li>}

                {cellRating && <li className="rec-subhead-cell-rating">{cellRating}</li>}

                {favoriteEntityId && (
                    <li>
                        <FavoriteHeart
                            entityId={favoriteEntityId}
                            entityType={favoriteEntityType}
                            parentId={favoriteParentId}
                            parentType={favoriteParentType}
                            showFavoriteText
                            key="favorite-button"
                        />
                    </li>
                )}
            </ul>
        </div>
    );
}
